import { modules, usersKey, assetTypeKey, workflowStageKey, languageKey, contentTypeKey, termKey } from '../constant'
import { setCounterForAdvanceQuery } from '../helper'
import { advanceQueryParserForEntries } from './entriesQueryParser'
import { updateSelectedContentTypeStatus } from '../advanceQueryEntries'

import { advanceQueryAssetParser } from './assetQueryParser'



const getPopulatedQueryUids = (queryObjectArray) => {
  const users = []
  const contentTypes = []
  const languages = []
  const types = []
  const workflowStages = []
  const terms = []

  if (!Array.isArray(queryObjectArray)) {
    return { users, contentTypes, languages, types }
  }

  for (let query of queryObjectArray) {
    const queryKey = Object.keys(query)[0]

    if (usersKey.includes(queryKey)) {
      const value = Object.values(query[queryKey])[0]
      if (!users.includes(value)) {
        users.push(value)
      }
    }

    if (assetTypeKey.includes(queryKey)) {
      const value = Object.values(query[queryKey])[0]
      if (!types.includes(value)) {
        types.push(value)
      }
    }

    if (workflowStageKey === queryKey) {
      const value = Object.values(query[queryKey])[0]
      if (!workflowStages.includes(value)) {
        workflowStages.push(value)
      }
    }

    if (languageKey === queryKey) {
      const value = Object.values(query[queryKey])[0]
      if (!languages.includes(value)) {
        languages.push(value)
      }
    }

    if (contentTypeKey === queryKey && typeof query[queryKey] === 'object') {
      const value = Object.values(query[queryKey])[0]
      if (!contentTypes.includes(value)) {
        contentTypes.push(value)
      }
    }

    if (termKey === queryKey) {
      const { $in: matchTermsArray = [], $nin: notMatchTermsArray=[] } = query[queryKey] || {}
      console.log('getPopulcted',{matchTermsArray, notMatchTermsArray, } )

      if (matchTermsArray.length || notMatchTermsArray.length) {
        let value = matchTermsArray[0] || notMatchTermsArray[0]
        terms.push(value)
      }
    }

    if (queryKey === '$or' || queryKey === '$and') {
      const queryArray = query[queryKey]
      const valuesObject = getPopulatedQueryUids(queryArray)

      users.push(...valuesObject.users)
      contentTypes.push(...valuesObject.contentTypes)
      languages.push(...valuesObject.languages)
      types.push(...valuesObject.types)
      workflowStages.push(...valuesObject.workflowStages)
      terms.push(...valuesObject.terms)
    }
  }

  return { users, contentTypes, languages, types, workflowStages, terms }
}

export const fetchDataByValue = async ({
  users = [],
  types = [],
  contentTypes = [],
  languages = [],
  workflowStages = [],
  terms = [],
  fetchData
}) => {
  try {
    let uniqCts = Array.from(new Set(contentTypes))
    let uniqWorkflowStages = Array.from(new Set(workflowStages))

    console.log('terms', terms)
    const { fetchUsers, fetchAssetTypes, fetchContentTypes, fetchTerms, fetchLanguages, fetchWorkflowStage } = fetchData
    // let uniqTerms = Array.from(new Set(terms))
    // console.log("before uniqTerms", uniqTerms)
    // uniqTerms = uniqTerms.filter((obj) => Object.keys(obj).length > 0)
    // uniqTerms = uniqTerms.length ? uniqTerms : []
    // console.log("after uniqTerms", uniqTerms)

    const [userResponse, typesResponse, ctResponse, termsResponse, langResponse, workflowStagesResponse] =
      await Promise.all([
        users.length && fetchUsers && fetchUsers({}),
        types.length && fetchAssetTypes && fetchAssetTypes({}),
        contentTypes.length && fetchContentTypes && fetchContentTypes({ query: { uid: { $in: uniqCts } } }),
        terms.length && fetchTerms && fetchTerms({ terms }),
        languages.length && fetchLanguages && fetchLanguages({}),
        workflowStages.length &&
          fetchWorkflowStage &&
          fetchWorkflowStage({ query: { uid: { $in: uniqWorkflowStages } } })
      ])

    const response = {
      userResponse: (userResponse && userResponse.data) || [],
      typesResponse: (typesResponse && typesResponse.data) || [],
      ctResponse: (ctResponse && ctResponse.data) || [],
      termsResponse: (termsResponse && termsResponse.data) || [],
      langResponse: (langResponse && langResponse.data) || [],
      workflowStagesResponse: (workflowStagesResponse && workflowStagesResponse.data) || []
    }
    return response
  } catch (error) {
    throw error
  }
}

export const fetchDataForQuery = async (rawQueryObjectArray, fetchData) => {
  try {
    const { users, types, contentTypes, languages, workflowStages, terms } = await getPopulatedQueryUids(
      rawQueryObjectArray
    )
    const response = await fetchDataByValue({ users, types, contentTypes, languages, workflowStages, terms, fetchData })
    return response
  } catch (error) {
    console.log('fetchDataForQuery error', error)
    throw error
  }
}

export const advanceQueryParser = async ({ query, selectedModule, fetchData, cache = null }) => {
  try {
    let advanceQueryArray = []

    let cacheResponse
    if (cache) {
      cacheResponse = cache
    } else {
      cacheResponse = await fetchDataForQuery(Object.values(query)[0], fetchData)
    }

    if (selectedModule === modules[0].value) {
      advanceQueryArray = await advanceQueryParserForEntries(query, cacheResponse, fetchData, null, true)
      //todo test it
      updateSelectedContentTypeStatus({ queryObject: advanceQueryArray, type: 'default' })
    }

    if (selectedModule === modules[1].value) {
      advanceQueryArray = await advanceQueryAssetParser(query, selectedModule, fetchData, cacheResponse, true)
    }

    setCounterForAdvanceQuery([advanceQueryArray], -1)
    return [advanceQueryArray]
  } catch (error) {
    console.log('error', error)
    throw error
  }
}
